export const syslog_levels = {
    'USER': 0,
    'ERROR': 1,
    'WARNING': 2,
    'INFO': 3,
    'DEBUG': 4,
    'TRACE': 5
}

export const syslog_subsystems = {
    'ALL_SUBSYSTEMS': 0,
    'BONDID': 1,
    'MAIN': 2,
    'CTRL_MR196W': 3,
    'BMOCK': 4,
    'BWIFI': 5,
    'HAL_PIN': 6,
    'FUNNEL': 7,
    'TRANSPORT_AWS': 8,
    'AWS_IOT': 9,
    'TRANSPORT_CLI': 10,
    'BEAU': 11,
    'BOND_ID': 12,
    'CRC32': 13,
    'OSAL': 14,
    'MBEDTLS': 15,
    'BDEBUG': 16,
    'TRANSPORT_PIGEON': 17,
    'BRSP': 18,
    'BHOOK': 19,
    'BSPI': 20,
    'BOTA': 21,
    'BDOWNLOAD': 22,
    'TLS': 23,
    'FCC_CLI': 24,
    'SI446X': 25,
    'CTRL_MR101Z': 26,
    'BFEATURE': 27,
    'RLE': 28,
    'REMOTERX': 29,
    'BOND_RESET': 30,
    'CJSON': 31,
    'BLED': 32,
    'TRANSPORT_HTTP': 33,
    'BOND_TOKEN': 34,
    'BBRIDGE': 35,
    'RFMAN': 36,
    'SMCU': 37,
    'TRANSPORT_V1': 38,
    'BLOCATION': 39,
    'BOOT_PATCH': 40,
    'CTRL32': 41,
    'SENTRY': 42,
    'BSTRING': 43,
    'BONDSCRIPT': 44,
    'BPUP': 45,
    'CTRL_PWM': 46,
    'BHOLD': 47,
    'BPANEL': 48,
    'BTIME': 49,
    'SKEDS': 50,
    'BUPLOAD': 51,
    'BPOWER': 52,
    'PEXP': 53,
    'BI2C': 54,
    'BETHERNET': 55,
    'BLOCALE': 56,
    'BBACKUP': 57,
    'CTRL32_GRAFFITI': 58,
    'BGROUP': 59,
    'BBCAP': 60,
    'BOND_SYNC': 61,
    'FOFOCA': 62,
    'BDEVICE': 63,
    'BHK': 64,
    'SIDEKICK': 65,
    'BSIDEKICK': 66,
    'BRIDGE_INFO': 67,
    'CTRL_RGBW': 68,
    'BI2S': 69,
    'MECHO': 70,
    'TROY': 71,
    'BPICO': 72,
    'VIRTUALRC': 73,
    'BSCENE': 74,
    'BWEATHER': 75,
    'BMEMFAULT': 76,
    'POWERVIEW': 77,
    'WMANCER': 78,
    'DRAPER': 79,
    'MATTERHORN': 80,
    'BREGF': 81,
    'BENCODERMEM': 82,
    'BMOTORUI': 83,
    'HBRIDGE': 84,
    'BENCODER': 85,
    'BMOTOR': 86,
    'BMOTION': 87,
    'BBATTERY': 88,
    'JCBD': 89,
    'BRELAY_AC': 90,
    'SUGARBUSH': 91,
    'BSLEEP': 92
}

export const reverse_syslog_levels = Object.fromEntries(
    Object.entries(syslog_levels).map(([key, value]) => [value, key])
);

export const reverse_syslog_subsystems = Object.fromEntries(
    Object.entries(syslog_subsystems).map(([key, value]) => [value, key])
);
